import type { FC } from 'react';
import { useTheme } from '@mui/material/styles';
import { color, diagramStyle } from './palette';

/**
 * The two RLS paths: Path A scopes members by entity group membership, Path B scopes third parties by an engagement's
 * scope, Path B writes are an allowlist, and the two paths never cross.
 */
export const TwoRlsPaths: FC = () => {
  const theme = useTheme();
  const sub = { fill: color.muted, fontSize: 13 } as const;
  const lbl = { fontSize: 15, fontWeight: 600 } as const;
  const row = { fontSize: 14, fill: color.fg } as const;
  const mono = { fontSize: 14, fill: color.fg, fontFamily: 'monospace' } as const;
  const lane = (y: number, title: string, who: string, key: string, table: string, rows: string, stroke: string) => (
    <g key={title}>
      <text x="20" y={y + 25} style={lbl} fill={stroke}>
        {title}
      </text>
      <text x="20" y={y + 46} style={sub}>
        {who}
      </text>
      <rect x="150" y={y + 8} width="190" height="44" rx="8" fill="none" stroke={stroke} strokeWidth="2.5" />
      <text x="245" y={y + 35} textAnchor="middle" style={mono}>
        {key}
      </text>
      <line x1="342" y1={y + 30} x2="394" y2={y + 30} stroke={color.muted} strokeWidth="2" markerEnd="url(#academy-arrow-rls)" />
      <rect x="398" y={y + 8} width="290" height="44" rx="8" fill="none" stroke={stroke} strokeWidth="2.5" />
      <text x="543" y={y + 35} textAnchor="middle" style={mono}>
        {table}
      </text>
      <line x1="690" y1={y + 30} x2="742" y2={y + 30} stroke={color.muted} strokeWidth="2" markerEnd="url(#academy-arrow-rls)" />
      <rect x="746" y={y + 8} width="174" height="44" rx="8" fill={stroke} fillOpacity=".15" stroke="none" />
      <text x="833" y={y + 35} textAnchor="middle" style={row}>
        {rows}
      </text>
    </g>
  );

  return (
    <svg viewBox="0 0 940 290" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="The two RLS paths" style={diagramStyle(theme)}>
      <defs>
        <marker id="academy-arrow-rls" markerWidth="8" markerHeight="8" refX="7" refY="4" orient="auto">
          <path d="M0,0 L8,4 L0,8 z" fill={color.muted} />
        </marker>
      </defs>
      {lane(40, 'Path A', 'members', 'entity_group_id', 'iam_entity_group_members', 'rows in their groups', color.accent)}
      {/* The gap: nothing joins the two */}
      <line x1="20" y1="142" x2="390" y2="142" stroke={color.muted} strokeWidth="1.5" strokeDasharray="6 6" opacity=".6" />
      <text x="470" y="147" textAnchor="middle" style={sub}>
        the paths never cross
      </text>
      <line x1="550" y1="142" x2="920" y2="142" stroke={color.muted} strokeWidth="1.5" strokeDasharray="6 6" opacity=".6" />
      {lane(180, 'Path B', 'third parties', 'engagement_id', 'iam_external_party_engagements', 'rows in scope', color.muted)}
      <rect x="398" y="244" width="170" height="26" rx="13" fill="none" stroke={color.warn} strokeWidth="1.5" />
      <text x="483" y="262" textAnchor="middle" fontSize="13" fontWeight="600" fill={color.warn}>
        writes: allowlist
      </text>
    </svg>
  );
};
